import React from "react"
import { Link } from "react-router-dom"
import axios from "axios"
import { PORT } from "../../config"
import { notify } from "react-notify-toast"
import DeletePopup from "./ConfirmationBox"
import { addDays } from "date-fns"
import "react-datepicker/dist/react-datepicker.css"
import "./UserProfile.css"
import "../Payments/Payments.css"
import { getStates, handleLogErrorToSlack } from "../../Helper"
import ImageCrops from "./ImageCrops"
import FormField from "../../Components/FormField/FormField"
import FormDropdown from "../../Components/FormField/FormDropdown"
import FormDatePicker from "../../Components/FormField/FormDatePicker"
import CheckableButton from "../../Components/CheckableButton/CheckableButton"
import ButtonContainer from "../../Components/CheckableButton/ButtonContainer"
import HoverIcon from "../../Components/FormField/HoverIcon-nova";
import { API } from "../../API";
import { CircularProgress } from "@mui/material";

//redux
import { connect } from "react-redux"

require("./PersonalDetails.css")

const URL = PORT
let Countries = []
const States = getStates().sort()

class PersonalIdForm2 extends React.Component {
  constructor(props) {
    super(props)
    let user = props.user

    if (user === null) {
      window.location = "./login"
    }

    this.state = {
      issuing_place_options: [],
      deleteidentificationPopup: false,
      file: null,
      preview: null,
      show: false,
      borderRadius: 0,
      width: 200,
      height: 200,
      scale: 1,
      image: "",
      imageName: "",
      allowZoomOut: false,
      showPopup: false,
    }
  }

  uploadDocument = (id) => {
    document.getElementById(id).click()
  }

  setIssuingPlaceOptions = (id_document_type) => {
    this.setState({
      issuing_place_options:
        id_document_type === "Passport" ? Countries : States,
    })
  }

  componentDidMount = () => {
    //get a complete list of countries
    API.getCountries().then((res) => {
      Countries = res.data.sort()
      this.setIssuingPlaceOptions(this.props.state.id_document_type)
    })
  }

  isFileUploaded = () => {
    var isValid = true
    if (
      !this.state.user.identification_filename ||
      !this.state.identification_filename
    ) {
      notify.show("Please provide Identification document")
      isValid = false
    }
    return isValid
  }

  handleRadioChange = (e) => {
    this.props.handleRadioChange(e)
    this.setIssuingPlaceOptions(e.target.title)
  }

  onFileUpload = (fileName, url) => {
    this.props.handleStateChange("identification_filename", fileName);
    this.props.handleStateChange("identification_url", url);
  };

  // not sure if this is being used?
  // Save file to AWS S3
  saveFile = async (file) => {
    this.setState({
      isLoading: true
    });
    const fileName = 'identification';

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("fileName", `${fileName}`)
      const response = await API.uploadCompressedFileToS3(formData)
  
      const url = response?.data?.data
      const cut_length = "https://platform-backend-files.s3.amazonaws.com/".length;
      const suffix = url.substring(cut_length, url.length);
      const prefix = "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path=";
      const new_url = prefix + suffix;
      this.onFileUpload(file.name, new_url);
      this.setState({
        isLoading: false
      });
    } catch (error) {
      this.setState({
        isLoading: false
      });
      handleLogErrorToSlack(error, true);
      notify.show(JSON.stringify(error), "error");
    }
  }

  handleIdentificationFileChange = () => {
    var isValidFile = false
    let idFile = this.uploadInput.files[0]
    let filesize = this.uploadInput.files[0].size >> 10

    isValidFile = this.validateFile(idFile, "identification")
    if (isValidFile) {
      this.saveFile(idFile)
    }
  }

  // Removes file from state
  deleteFile = (isDelete, fileName, popupStatus) => {
    var field = fileName + "_filename"
    var popUpState = "delete" + fileName + "Popup"
    // var buttonID = "btnUpload_" + fileName;
    if (isDelete) {
      notify.show("File deleted successfully")
      this.props.handleStateChange(fileName + "_filename", null)
      this.props.handleStateChange(fileName + "_url", null)
      // document.getElementById(buttonID).disabled = false;
    } else {
    }
    this.setState({ [popUpState]: popupStatus })
  }

  validateFile = (file, filename) => {
    let isValid = false
    if (file !== null && file !== undefined) {
      isValid = true
    }
    return isValid
  }

  // Sets file details state when file loads
  onFileLoad = (e) => {
    this.setState({ file: e })
    this.setState({ Name: e.name })
    var isValidFile = false
    let identity = e
    isValidFile = this.validateFile(identity, "identification")
  }

  // Returns true if file type is pdf else false; use to open image crop popup if not pdf
  fileIsPdf = () => {
    let identification = this.uploadInput.files[0]
    this.setState({ image: this.uploadInput.files[0] })
    this.setState({ imageName: identification.name })
    // this.setState({wwcc_filename: this.uploadWWCC.files[0]});

    let isPdf = true
    let filesplit = identification.name.split(".")
    let filetype = filesplit[1]
    if (filetype !== "pdf") {
      isPdf = false
    }
    return isPdf
  }

  // File change handler
  // handleChage = () => {
  // 	let newUserData = JSON.parse(window.localStorage.getItem("user"));
  // 	this.setState({ user: newUserData });
  // 	this.setState({
  // 		identification_filename: newUserData.identification_filename,
  // 	});
  // };

  // parseDate = (dateString) => {
  // 	const d = dateString.split(/\D+/);
  // 	return new Date(Date.UTC(d[0], --d[1], d[2], d[3], d[4], d[5], d[6]));
  // }

  onImageCrop = (filename, url) => {
    this.props.handleStateChange("identification_filename", filename)
    this.props.handleStateChange("identification_url", url)
  }

  togglePopup = () => {
    this.setState({ showPopup: !this.state.showPopup })
  }

  render() {
    return (
      <div className="row">
        {/* TESTING BEFORE IMPLEMENTATION */}
        {/* <script src='https://cdn.jsdelivr.net/npm/places.js@1.16.4'></script> */}
        <div className="col-md-12">
          <div className="auth-text-top mb-5">
            {/* residential status radio button */}
            <ButtonContainer label="Select one form of identification">
              <CheckableButton
                id="drivers_license"
                name="id_document_type"
                onChange={this.handleRadioChange}
                checked={
                  this.props.state.id_document_type ===
                  "Australian Driver's Licence"
                }
                title="Australian Driver's Licence"
                required
              >
                Australian Driver Licence
                  </CheckableButton>
              <CheckableButton
                id="passport"
                name="id_document_type"
                onChange={this.handleRadioChange}
                checked={this.props.state.id_document_type === "Passport"}
                title="Passport"
                required
              >
                Passport
                  </CheckableButton>
            </ButtonContainer>

            {/* document number */}
            <FormField
              label={this.props.state.id_document_type + " No."}
              id="identification_document_number"
              onChange={this.props.handleFormFieldChange}
              value={this.props.state.identification_document_number}
              maxLength="10"
              required
              placeholder={
                "Insert " +
                (this.props.state.id_document_type === "Passport"
                  ? "Passport"
                  : "Driver's Licence") +
                " Number"
              }
            />

            {/* document issuing place */}
            {/* TODO: Chane select control to searchable dropdown */}
            <FormDropdown
              label={
                "Issuing " +
                (this.props.state.id_document_type === "Passport"
                  ? "Country"
                  : "State")
              }
              id="issuing_place"
              name="issuing_place"
              value={
                this.state.issuing_place_options.includes(
                  this.props.state.issuing_place
                )
                  ? this.props.state.issuing_place
                  : ""
              }
              onChange={this.props.handleFormFieldChange}
              required
            >
              <option disabled value="">
                Please Select
                  </option>
              {this.state.issuing_place_options.map((place) => {
                return <option key={place}>{place}</option>
              })}
            </FormDropdown>

            {/* expiry date */}
            <FormDatePicker
              label={
                this.props.state.id_document_type === "Passport"
                  ? "Passport Expiry"
                  : "Licence" + " Expiry"
              }
              id="id_document_expiry"
              selected={this.props.state.id_document_expiry}
              // placeholderText={new Date()
              //   .toLocaleDateString()
              //   .split(/\//)
              //   .join("-")}
              // date should not be prefilled
              placeholderText="Please Select"
              showYearDropdown
              showMonthDropdown
              isClearable
              showPopperArrow={false}
              minDate={addDays(new Date(), 0)}
              dropdownMode="select"
              dateFormatCalendar="MMMM"
              dateFormat="dd-MM-yyyy"
              yearDropdownItemNumber={10}
              scrollableYearDropdown
              onChange={this.props.handleDateChange}
              required
            />

            {/* document upload */}
            <FormField
              label={
                "Upload " +
                (this.props.state.id_document_type === "Passport"
                  ? "Passport"
                  : "Driver's Licence")
              }
              placeholder={
                this.props.state.identification_filename
                  ? this.props.state.identification_filename
                  : "Please attach a photo of your " +
                  (this.props.state.id_document_type === "Passport"
                    ? "Passport in PNG, JPEG or JPG format"
                    : "Driver's Licence in PNG, JPEG or JPG format")
              }
              disabled
              sideButton={{
                label: "Upload",
                id: "btnUpload_identification",
                type: "button",
                required: true,
                disabled: this.props.state.identification_filename || this.state.isLoading
                  ? true
                  : false,
                onClick: () => this.uploadDocument("identification"),
              }}
              header={
                <HoverIcon
                  icon="info circle"
                  color="grey"
                  text="Please upload a file less than 600KB."
                />
              }
              footer={
                this.props.state.identification_filename ? (
                  <div className="text-left d-flex">
                    {/* <Link
                          to={{
                            pathname: `/pdfViewer?id=${this.props.state.identification_url}`,
                          }}
                          target="_blank"
                        >
                          <p className="uploaded-file-name mt-1 ml-1">
                            {this.props.state.identification_filename}
                          </p>
                        </Link> */}
                    <a href={`/NavigateToFileViewer?fileurl=${this.props.state.identification_url}`} target="_blank">
                      <p className="uploaded-file-name mt-1 ml-1">
                        {this.props.state.identification_filename}
                      </p>
                    </a>
                    <i
                      className="mdi mdi-delete-circle d-flex mt-1 ml-1 uploaded-file-delete-icon"
                      onClick={() =>
                        this.setState({
                          deleteidentificationPopup: true,
                        })
                      }
                    ></i>
                    {this.state.deleteidentificationPopup && (
                      <DeletePopup
                        togglePopup={(isDelete) =>
                          this.deleteFile(isDelete, "identification", false)
                        }
                      />
                    )}
                  </div>
                ) : (
                  ""
                )
              }
            >
              {
                this.state.isLoading && (
                  <CircularProgress />
                )
              }
              <input
                type="file"
                id="identification"
                name="identification"
                onChange={() =>
                  this.fileIsPdf()
                    ? this.handleIdentificationFileChange()
                    : this.setState({ showPopup: true })
                }
                ref={(ref) => {
                  this.uploadInput = ref
                }}
                style={{ display: "none" }}
                accept="image/*, .pdf"
              />
              <div>
                {this.state.showPopup && (
                  <ImageCrops
                    imageSrc={this.state.image}
                    user={this.props.user}
                    fileType="identification"
                    action={this.onImageCrop}
                    togglePopup={this.togglePopup}
                  />
                )}
              </div>
            </FormField>
          </div>
        </div>
      </div>
    )
  }
}

//Map root state to this component
const mapStateToProps = function (state) {
  return {
    user: state.user.user,
  }
}

export default connect(mapStateToProps)(PersonalIdForm2)
